import { useInit } from "@follosoft/react-components";

const REQUIRE_OPT_IN_KEY = "require_opt_in_confirmation";

/**
 * Whether the account requires an opt-in confirmation before alerting a
 * contact (the `require_opt_in_confirmation` setting from `/init`). When it is
 * on, the drawer spells out which channels trigger an opt-in message; when it
 * is off, no such explanation is shown.
 */
export const useRequireOptIn = (): boolean => {
  const { settings } = useInit();

  return Boolean(settings?.find((setting) => setting.attributes.key === REQUIRE_OPT_IN_KEY)?.attributes.value);
};
